<!--
    @修改人：黎柏祺
    @修改时间：2018-12-14
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: zabbix监控页
-->
<template>
    <div class="zabbixMonitor__content">
      <div class="zabbixMonitor__operation mb-base">
        <el-button type="primary" v-show="!isAmend" @click="e_editMode" v-text="$t('common.edit')" v-g-rac="gRac('zabbixMonitor_edit')"></el-button>
        <el-button type="primary" v-show="isAmend" @click="e_add" v-text="$t('common.add')" v-g-rac="gRac('zabbixMonitor_edit')"></el-button>
        <el-button type="primary" v-show="isAmend" @click="e_edit" v-text="$t('common.edit')" v-g-rac="gRac('zabbixMonitor_edit')"></el-button>
        <el-button type="danger" v-show="isAmend" @click="e_delete" v-text="$t('common.delete')" v-g-rac="gRac('zabbixMonitor_edit')"></el-button>
        <el-button type="primary" v-show="isAmend" @click="e_save" v-text="$t('common.save')" v-g-rac="gRac('zabbixMonitor_edit')"></el-button>
        <el-button v-show="isAmend" @click="e_cancel" v-text="$t('common.cancel')"></el-button>
        <span v-show="isAmend" class="zabbixMonitor__operation--text" v-text="selectedNote"></span>
      </div>
      <div class="zabbix_color_box">
        <div class="zabbix_color_item zabbix_color_5">灾难</div>
        <div class="zabbix_color_item zabbix_color_4">严重</div>
        <div class="zabbix_color_item zabbix_color_3">一般严重</div>
        <div class="zabbix_color_item zabbix_color_2">一般告警</div>
        <div class="zabbix_color_item zabbix_color_1">正常</div>
        <div class="zabbix_color_item zabbix_color_0">离线</div>
      </div>
      <div class="zabbixMonitor__editor">
        <div id="page"></div>
      </div>
      <dialog-form
        key="zabbixForm"
        :title="dialogTitle" 
        :size="3" 
        :label-size="2" 
        :visible.sync="dialogFormShow" 
        :model="dialogModel"
        :input-data="dialogData"
        :rules="dialogFormRule"
        :is-extra="isExtra"
        :extraLabel="testLabel"
        :extra-fun="e_test"
        :cancel-fun="e_quit"
        :confirm-fun="e_submit">
      </dialog-form>
    </div>
  </template>
  <script type="text/javascript">
    import rac from '@/plugins/rac-mixin'
    import zabbixBiz from '@/logic/intelligentMonitor/zabbixMonitorBiz.js'
    import cmdbBiz from '@/logic/cmdb/cmdbBiz.js'
    import dic from '@/components/mixins/dic'
    import G6 from '@antv/g6'
    import dialogForm from '@/components/dialogForm'
    import validateConfig from '@/utils/validate'
    import { extend } from '@/utils/tool'
    const G6Plugins = require('@antv/g6/build/plugins')
    const NETWORK_IMG = require('../../assets/image/intelligentMonitor/network_icon.png')
    const dagre = new G6Plugins['layout.dagre']()
    const tooltip = new G6Plugins['tool.tooltip']({
      getTooltip ({item}) {
        const model = item.getModel()
        return `<div>${model.title ? model.title : ''}</div>`
      }
    })
    const CHECK_INTERVAL_60 = 60 * 1000
    const STATUS_COLOR = {
      '0': {
        background: '#F3F3F3', // 灰色
        border: '#F3F3F3'
      },
      '1': {
        background: '#1FC35F', // 绿色
        border: '#1FC35F'
      },
      '2': {
        background: '#DFC049', // 黄色
        border: '#DFC049'
      },
      '3': {
        background: '#FF6C6C', // 粉色
        border: '#FF6C6C'
      },
      '4': {
        background: '#FF0000', // 红色
        border: '#FF0000'
      },
      '5': {
        background: '#990000', // 深红色
        border: '#990000'
      },
      'selected': {
        background: '#b6ddf7',
        border: '#0B8DE5'
      }
    }
    // const CHECK_INTERVAL_30 = 30 * 1000
    // const CHECK_INTERVAL_LIST = {}
    // CHECK_INTERVAL_LIST[CHECK_INTERVAL_60] = '1min'
    // CHECK_INTERVAL_LIST[CHECK_INTERVAL_30] = '30s'
    export default {
      mixins: [rac, dic],
      components: {
        dialogForm
      },
      data () {
        return {
          nodeData: null,
          nodeStatus: {},
          networkOption: null,
          interval: CHECK_INTERVAL_60,
          alarmLevelList: {},
          timer: null,
          delayTimer: null,
          delayData: null,
          isAmend: false,
          editor: null,
          selectedNote: '',
          selectedItem: {},
          dialogTitle: '',
          dialogModel: {},
          dialogData: [],
          dialogFormShow: false,
          dialogFormRule: {},
          siteNameList: {},
          curNodeData: [],
          testLabel: '',
          isExtra: true
        }
      },
      watch: {
        nodeStatus: {
          deep: true,
          handler: function (val) {
            this.setNodeStatus(val)
          }
        },
        delayData (val) {
          this.setNodeData(this.nodeData)
        },
        '$route' (newV, oldV) {
          if (oldV.name === 'zabbixMonitor') {
            this.clearTimer()
            this.clearDataTimer()
          }
          if (newV.name === 'zabbixMonitor') {
            this.getNode()
          }
        }
      },
      methods: {
        preSetData () {
          Promise.all([this.dGetDictionaryByCode('zabbix_alarm_level'), cmdbBiz.allSite().then((data) => {
            let obj = {}
            data.map((site) => {
              obj[site.siteCode] = site.name
            })
            this.siteNameList = obj
            this.siteNameList['none'] = this.$t('zabbixMonitor.none')
          })]).then(() => {
            this.alarmLevelList = { ...this.dDictionary.zabbix_alarm_level }
            this.setDialogData()
          }).then(() => {
            this.getNode()
          })
        },
        setDialogData () {
          this.dialogData = [
            {
              label: this.$t('zabbixMonitor.name'),
              key: 'name',
              inputWidth: '400px'
            },
            {
              label: this.$t('zabbixMonitor.code'),
              key: 'code',
              inputWidth: '400px'
            },
            {
              label: this.$t('zabbixMonitor.hostName'),
              key: 'siteCode',
              type: 'select',
              inputWidth: '400px',
              select: this.siteNameList
            },
            {
              label: this.$t('zabbixMonitor.username'),
              key: 'username',
              inputWidth: '400px'
            },
            {
              label: this.$t('zabbixMonitor.password'),
              key: 'password',
              inputWidth: '400px',
              type: 'password'
            },
            {
              label: this.$t('zabbixMonitor.ping'),
              key: 'ping',
              inputWidth: '400px'
            },
            {
              label: this.$t('zabbixMonitor.url'),
              key: 'url',
              placeholder: this.$t('zabbixMonitor.urlTips'),
              inputWidth: '400px'
            },
            {
              label: this.$t('zabbixMonitor.to'),
              key: 'to',
              type: 'selectBox',
              selectBox: [],
              selectBoxChange: () => {}
            }
          ]
          this.dialogFormRule = {
            name: [{ ...validateConfig.common.notEmpty }],
            code: [{ ...validateConfig.common.notEmpty }],
            siteCode: [{ ...validateConfig.common.notEmpty }],
            username: [{ ...validateConfig.common.notEmpty }],
            password: [{ ...validateConfig.common.notEmpty }],
            ping: [{ ...validateConfig.common.notEmpty }],
            url: [{ ...validateConfig.common.notEmpty }]
          }
        },
        setSiteList (isAmend) {
          let siteList = []
          this.curNodeData.map((item) => {
            if (isAmend && item.code !== this.selectedItem.code) {
              siteList.push({label: item.name, key: item.code})
            }
            if (!isAmend) {
              siteList.push({label: item.name, key: item.code})
            }
          })
          this.$set(this.dialogData[7], 'selectBox', siteList)
        },
        init () {
          this.testLabel = this.$t('zabbixMonitor.test')
          this.preSetData()
        },
        initEditor (data) {
          if (this.editor !== null) {
            this.editor.destroy()
          }
          this.registerNode()
          !this.isAmend && this.registerBehaviour()
          this.editor = new G6.Graph({
            container: 'page',
            fitView: 'cc',
            height: window.innerHeight - 230, // 画布高
            plugins: this.isAmend ? [dagre] : [dagre, tooltip],
            fitViewPadding: 20,
            defaultIntersectBox: 'rect', // 使用矩形包围盒
            modes: {
              default: ['hehaviourName'],
              mouseBehavior: ['mouseEnterFillBlue', 'mouseLeaveResetFill']
            },
            mode: 'mouseBehavior'
          })
          this.editor.on('node:click', ev => {
            if (this.isAmend) {
              this.selectedNote = `${this.$t('zabbixMonitor.selectedItem')}${ev.item.model.primaryName ? ev.item.model.primaryName : ev.item.model.name}`
              this.selectedItem = {
                name: ev.item.model.name,
                code: ev.item.model.code,
                siteCode: ev.item.model.siteCode,
                username: ev.item.model.username,
                password: ev.item.model.password,
                ping: ev.item.model.ping,
                url: ev.item.model.url,
                to: ev.item.model.to
              }
            } else {
              if (ev.item.model.url) {
                zabbixBiz.test({username: ev.item.model.username, password: ev.item.model.password, url: ev.item.model.url}).then((data) => {
                  this.$confirm(this.$t('zabbixMonitor.tipsHead') + ev.item.model.url + this.$t('zabbixMonitor.tipsFoot'), this.$t('zabbixMonitor.tipsTitle'), {
                    type: 'warning'
                  }).then(() => {
                    window.open(data.location, 'zabbix')
                  }).catch(() => {})
                })
              }
            }
          })
          this.editor.edge({
            style: {
              endArrow: true
            }
          })
          this.editor.read(data)
        },
        registerNode () {
          const isAmend = this.isAmend
          G6.registerNode('netWork', {
            draw (item) {
              const group = item.getGraphicGroup()
              const model = item.getModel()
              group.addShape('text', {
                attrs: {
                  x: 0,
                  y: 30,
                  fill: '#333',
                  text: isAmend && model.primaryName ? model.primaryName : model.nodeName,
                  textBaseline: 'top',
                  textAlign: 'center'
                }
              })
              !isAmend && group.addShape('rect', {
                attrs: {
                  x: -30,
                  y: -30,
                  width: 60,
                  height: 60,
                  fill: model.type ? STATUS_COLOR[model.type].background : '#cccccc',
                  stroke: model.type ? STATUS_COLOR[model.type].border : '#cccccc'
                }
              })
              return group.addShape('image', {
                attrs: {
                  x: -30,
                  y: -30,
                  width: 60,
                  height: 60,
                  img: NETWORK_IMG
                }
              })
            },
            anchor: []
          })
        },
        registerBehaviour () {
          const nData = this.nodeData
          G6.registerBehaviour('mouseEnterFillBlue', graph => {
            graph.behaviourOn('node:mouseenter', ev => {
              graph.update(ev.item, {
                type: 'selected'
              })
            })
          })
          G6.registerBehaviour('mouseLeaveResetFill', graph => {
            graph.behaviourOn('node:mouseleave', ev => {
              const index = nData.findIndex((item) => item.id === ev.item.model.id)
              graph.update(ev.item, {
                type: index !== -1 ? nData[index].type : ''
              })
            })
          })
        },
        getNode () {
          zabbixBiz.getNode().then((data) => {
            data.map((node, index) => {
              data[index].id = node.code
              data[index].primaryName = node.name
              data[index].title = this.getTitle()
            })
            this.nodeData = data
            this.setNodeData(data, true)
          })
        },
        setNodeData (data, init = false) {
          init && this.getTimeDelay()
          this.drawTopo(data)
          if (!init) return
          this.clearTimer()
          this.startTimer()
          this.clearDataTimer()
          this.delayDataTimer()
        },
        drawTopo (data) {
          const insertData = {
            nodes: [],
            edges: []
          }
          const tempDelayData = this.delayData
          data.map((node, index) => {
            for (const d in tempDelayData) {
              if (tempDelayData[d].from === node.code && (node.to.indexOf(tempDelayData[d].to) > -1)) {
                node[tempDelayData[d].to + 'delay'] = tempDelayData[d].time
              }
              this.$set(data, index, node)
            }
            insertData.nodes.push({
              ...node,
              shape: 'netWork'
            })
            node.to.map((target) => {
              if (data.some(d => d.id === target)) {
                insertData.edges.push({
                  source: node.id,
                  target: target
                })
              }
            })
          })
          this.initEditor(insertData)
        },
        setNodeStatus (data) { // 把每一个节点的nodeData和status结合到一起输出nodeData 此时每一个节点都包含了title 告警信息等信息.
          // 更新node的状态
          for (const key in data) {
            const status = data[key]
            this.nodeData.map((item, index) => {
              if (key === item.code) {
                let type = Number(status.status)
                const alarm = Number(status.priorityMax)
                let title = this.$t('zabbixMonitor.offLine')
                let nodeName = item.name
                if (!name.match(this.$t('zabbixMonitor.offLine'))) {
                  nodeName += '\n' + this.$t('zabbixMonitor.offLine')
                }
                if (type !== 0) {
                  type = alarm
                  title = this.getTitle(status.info)
                  nodeName = this.getName(nodeName, status.info)
                }
                item.type = type
                item.title = title
                item.nodeName = nodeName
                this.$set(this.nodeData, index, item)
              }
            })
          }
          this.setNodeData(this.nodeData)
        },
        getName (name, info) {
          let title = name.indexOf('\n') !== -1 ? name.split('\n')[0] : name
          if (info) {
            for (const key in info) {
              title += '\n'
              title += this.alarmLevelList[key] + '：' + info[key]
            }
          } else {
            title += '\n' + this.$t('zabbixMonitor.no')
          }
          return title
        },
        getTitle (info) { // 致命告警:7 \n 严重告警:6 \n 一般告警:7
          let title = ''
          if (info) {
            for (const key in info) {
              title += this.alarmLevelList[key] + '：' + info[key]
              title += '<br>'
            }
          } else {
            title += this.$t('zabbixMonitor.no')
          }
          return title
        },
        e_editMode () {
          this.isAmend = true
          this.curNodeData = extend(true, [], this.nodeData)
          this.drawTopo(this.curNodeData)
          this.clearTimer()
          this.clearDataTimer()
        },
        e_edit () {
          if (Object.keys(this.selectedItem).length !== 0) {
            this.setSiteList(true)
            this.dialogTitle = this.$t('zabbixMonitor.edit')
            this.dialogFormShow = true
            let selectIndex = this.curNodeData.findIndex(item => this.selectedItem.code === item.code)
            this.dialogModel = extend(true, {}, this.curNodeData[selectIndex])
          } else {
            this.$message({
              message: this.$t('zabbixMonitor.selectAlert'),
              type: 'warning'
            })
          }
        },
        e_add () {
          this.setSiteList(false)
          this.dialogTitle = this.$t('zabbixMonitor.add')
          this.dialogFormShow = true
          this.dialogModel = {
            name: '',
            code: '',
            siteCode: Object.keys(this.siteNameList)[0],
            username: '',
            password: '',
            ping: '',
            url: '',
            to: []
          }
        },
        e_delete () {
          if (Object.keys(this.selectedItem).length !== 0) {
            this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
              type: 'warning'
            }).then(() => {
              let selectIndex = this.curNodeData.findIndex(item => this.selectedItem.code === item.code)
              this.curNodeData.splice(selectIndex, 1)
              this.drawTopo(this.curNodeData)
              this.selectedItem = {}
              this.selectedNote = ''
            }).catch(() => {})
          } else {
            this.$message({
              message: this.$t('zabbixMonitor.selectAlert'),
              type: 'warning'
            })
          }
        },
        e_submit (data) {
          const subObj = extend(true, {}, data)
          subObj.primaryName = subObj.name
          subObj.id = subObj.code
          if (this.dialogTitle === this.$t('zabbixMonitor.add')) {
            this.curNodeData.push(subObj)
            this.drawTopo(this.curNodeData)
            this.dialogFormShow = false
          } else {
            let selectIndex = this.curNodeData.findIndex(item => subObj.code === item.code)
            this.curNodeData.splice(selectIndex, 1, subObj)
            this.drawTopo(this.curNodeData)
            this.dialogFormShow = false
          }
        },
        e_test (data) {
          zabbixBiz.test({username: data.username, password: data.password, url: data.url}).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
          })
        },
        e_save () {
          this.isAmend = false
          this.selectedItem = {}
          this.selectedNote = ''
          this.nodeData = extend(true, [], this.curNodeData)
          this.setNodeData(this.nodeData)
          const saveArr = []
          this.nodeData.map((item) => {
            saveArr.push({
              name: item.name,
              code: item.code,
              siteCode: item.siteCode === 'none' ? '' : item.siteCode,
              username: item.username,
              password: item.password,
              ping: item.ping,
              url: item.url,
              to: item.to
            })
          })
          zabbixBiz.save({data: saveArr}).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.clearTimer()
            this.startTimer()
            this.clearDataTimer()
            this.delayDataTimer()
          })
        },
        e_cancel () {
          this.isAmend = false
          this.selectedItem = {}
          this.selectedNote = ''
          this.setNodeData(this.nodeData)
        },
        e_quit () {
          this.dialogFormShow = false
        },
        e_stopTimer () {
          if (this.timer) {
            // this.refreshText = this.i18n.start
            this.clearTimer()
          } else {
            // this.refreshText = this.i18n.stop
            this.startTimer()
          }
        },
        clearTimer () {
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
          }
        },
        startTimer () {
          this.checkNodeStatus()
          this.timer = setInterval(this.checkNodeStatus, this.interval)
        },
        delayDataTimer () {
          this.delayTimer = setInterval(this.getTimeDelay, this.interval)
        },
        clearDataTimer () {
          if (this.delayTimer) {
            clearInterval(this.delayTimer)
            this.delayTimer = null
          }
        },
        checkNodeStatus () {
          zabbixBiz.getStatus().then((data) => {
            this.nodeStatus = data
          })
        },
        getTimeDelay () {
          zabbixBiz.getTimeDelay().then((d) => {
            this.delayData = d
          })
        }
      },
      mounted () {
        this.init() // 设置nodeData数据 和 nodestatus数据
      },
      destroyed () {
        this.clearTimer()
        this.clearDataTimer()
      }
    }
  </script>
  <style scoped>
    .zabbixMonitor__operation--text {
      float: right;
      font-weight: 700;
      font-size: 16px;
    }
    .zabbixMonitor__editor #page {
      border-radius: 2px;
      border: 7px solid #ddd;
      background: #F3F3F3;
    }
    .zabbix_color_box {
      position: absolute;
      left: 28px;
      top: 68px;
      z-index: 0;
    }
    .zabbix_color_item {
      border-width: 0px;
      display: inline-block;
      width: 60px;
      height: 25px;
      background: inherit;
      border: none;
      border-radius: 6px;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      font-size: 12px;
      color: #fff;
      text-align: center;
      line-height: 25px;
    }
    .zabbix_color_5 {
      background-color: #990000;
    }
    .zabbix_color_4 {
      background-color: #FF0000;
    }
    .zabbix_color_3 {
      background-color: #FF6C6C;
    }
    .zabbix_color_2 {
      background-color: #DFC049;
    }
    .zabbix_color_1 {
      background-color: #1FC35F;
    }
    .zabbix_color_0 {
      background-color: #8c8c8c;
    }
  </style>